export const ReportPageHeader = () => (
    <>
        <h3 className="hidden md:block text-2xl 2xl:text-3xl 3xl:text-5xl text-[var(--text-primary)] leading-6 3xl:!leading-[3.5rem] tracking-tight">
            My Report
        </h3>
        <h6 className="hidden md:block text-sm 2xl:text-base 3xl:text-xl 3xl:leading-6 lg:font-semibold text-[var(--text-secondary)]">
            A detail report insights of your eye exercise
        </h6>
    </>
)
